import Swal from 'sweetalert2/dist/sweetalert2.js';

export const showSwal = (error) => {
  Swal.fire({
    heightAuto: false,
    icon: 'error',
    title: 'Oops...',
    text: error,
  });
};

export const defaultSorted = [{ dataField: 'id', order: 'asc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '200', value: 200 },
  { text: '500', value: 500 },
];

export const initialFilter = {
  filter: {},
  sortOrder: 'asc', // asc||desc
  sortField: 'id',
  pageNumber: 1,
  pageSize: 10,
};

export const firebaseConfig = {
  apiKey: 'AIzaSyBE2KY6pOwcb2p4t845RT1_1DcBJr2j8hA',
  authDomain: 'patidar-vivah-9e60a.firebaseapp.com',
  projectId: 'testing-48160',
  storageBucket: 'testing-48160.appspot.com',
  messagingSenderId: '1045463344749',
  appId: '1:780450160596:web:3614824516c26ec29cc041',
  measurementId: 'G-PYSYER3FFH',
};

// export const firebaseConfig = {
//   apiKey: 'AIzaSyBE2KY6pOwcb2p4t845RT1_1DcBJr2j8hA',
//   authDomain: 'patidar-vivah-9e60a.firebaseapp.com',
//   projectId: 'patidar-vivah-9e60a',
//   storageBucket: 'patidar-vivah-9e60a.appspot.com',
//   messagingSenderId: '780450160596',
//   appId: '1:780450160596:web:3614824516c26ec29cc041',
//   measurementId: 'G-PYSYER3FFH',
// };
